import { SET_NOTIFICATION_DATA, SET_PAGE_NUMBER, SET_ROWS_PER_PAGE } from "../utils/constants/redux";
import { fetchPendingNotifications } from "../components/notification/notificationService";
import { ERROR, SOMETHING_WENT_WRONG } from "../utils/constants";
import AddAlertMessage from "../components/alert/Alert";

export const setPageNumber = (pageNumber) => ({
  type: SET_PAGE_NUMBER,
  payload: pageNumber,
});

export const setRowsPerPage = (rowsPerPage) => ({
  type: SET_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const fetchNotificationCount = (targetRegister) => async (dispatch) => {
  try {
    const result = await fetchPendingNotifications(targetRegister);
    dispatch({
      type: SET_NOTIFICATION_DATA,
      payload: {
        totalSize: result.totalSize || 0,
        objectList: result.objectList || [],
      },
    });
  } catch (error) {
    AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
  }
};
